// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1bE_O","audit":"styles_audit__1QmYB","content":"styles_content__3LVk_","btn":"styles_btn__34Qsn"};